module.exports = __webpack_public_path__ + "static/media/Backgroundvideo.3202ca74.webm";